import React, { useEffect } from 'react'
import { Formik } from 'formik'
import { ValidationSchemaProvider } from 'context/validationSchema'
import { useNavigatePrevent } from 'context/navigatePrevent'
import { CustomFieldsProvider } from 'context/customFields'
import { FormikFormWithCustomFields } from 'components/Shared/FormikForm/FormikFormWithCustomFields/FormikFormWithCustomFields'

export const isFieldRequired = (validationSchema, fieldName) => {
  if (!validationSchema) {
    return false
  }
  const properties = fieldName
    .split('.')
    // removes array references: "fields[0]" => "fields" to match validation schema field name
    .map(input => input.substr(0, input.indexOf('[')) || input)

  return properties.reduce((prev, curr) => {
    if (prev?._type === 'array') {
      return ((prev._subType && prev._subType.fields[curr]) || prev)
    }
    return prev && (prev.fields && prev.fields[curr])
  }, validationSchema)?.exclusiveTests?.required || false
}

export function FormikForm ({ validationSchema, preventNavigation = true, lockId, customFields, ...rest }) {
  const { setNavigationUnlocked, setNavigationBlocked } = useNavigatePrevent()

  useEffect(() => {
    if (preventNavigation) {
      setNavigationBlocked(lockId)
      return () => setNavigationUnlocked()
    }
  }, [setNavigationBlocked, setNavigationUnlocked, preventNavigation, lockId])

  return customFields ?
    <CustomFieldsProvider {...customFields}>
      <FormikFormWithCustomFields
        baseValidationSchema={validationSchema}
        {...rest}/>
    </CustomFieldsProvider> :
    <ValidationSchemaProvider schema={validationSchema}>
      <SimpleFormikForm
        validationSchema={validationSchema}
        {...rest}/>
    </ValidationSchemaProvider>

}

function SimpleFormikForm ({ children, onSubmit, ...rest }) {
  return <Formik
    onSubmit={values => onSubmit(values, () => Promise.resolve())}
    {...rest}>
    {children}
  </Formik>
}
